import React, { useEffect, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Accordion, Col, Row } from "react-bootstrap";
import { formatTimeHMS } from "@helpers";
import { LessonItem } from "./LessonItem";
import styles from "./style/LectureContentItem.module.css";
import { formatNumberText } from "@helpers";

const SectionContentItem = (props) => {
  const { section, index, isExpand: isExpandProp } = props;
  const [isExpand, setIsExpand] = useState(isExpandProp);

  useEffect(() => {
    setIsExpand(isExpandProp);
  }, [isExpandProp]);

  const handleClick = () => {
    setIsExpand(!isExpand);
  };

  const totalLectures = section?.lessons?.length || 0;

  return (
    <Accordion activeKey={!isExpand ? index.toString() : ""}>
      <Accordion.Header
        eventkey={index.toString()}
        onClick={handleClick}
        className={clsx(styles.container, "p-0")}
      >
        <Row className={clsx(styles.header)}>
          <Col xs={5} sm={8} className={styles.lectureTitle}>
            <i className="bi bi-collection-play mr-3"></i>
            <span>{section.title}</span>
          </Col>
          <Col xs={7} sm={4}>
            <Row>
              <Col className="text-right">
                {formatNumberText(totalLectures, "lesson")}
              </Col>
              <Col className="text-right">
                {formatTimeHMS(section.totalTime || 0)}
              </Col>
            </Row>
          </Col>
        </Row>
      </Accordion.Header>
      <Accordion.Body
        eventkey={index.toString()}
        className="p-0 overflow-hidden"
      >
        {section.lessons.map((lesson) => {
          return <LessonItem key={lesson.id} {...lesson} />;
        })}
      </Accordion.Body>
    </Accordion>
  );
};

/* required: display name */
SectionContentItem.displayName = "SectionContentItem";

/* required: props types */
SectionContentItem.propTypes = {
  section: PropTypes.object,
  index: PropTypes.number,
  isExpand: PropTypes.bool,
};

/* required: default props */
SectionContentItem.defaultProps = {
  isExpand: false,
};

export { SectionContentItem };
